import { Avatar, Box, Grid, Stack, TextField, Typography } from "@mui/material"
import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import Select_Dsas from "../Select_Dsas.js"
import useStyles from './styles.js'
import { usePositionPlayerFeuilleMatch } from "./usePositionPlayerFeuilleMatch.js"
import { CustoSelect } from "./CustoSelectFeuilleMatch.js"

const PositionResolver = ({editing = false, fullWidth, fullHeight, players = [], composition, onSelect, onChangeNumber, data, subs, isSmall, isPlayerNumberValued}) => {

    const left = 0
    const top = 0.06 * fullHeight
    const width = fullWidth
    const height = 0.88 * fullHeight

    const [clickedPlayers, setClickedPlayers] = useState(-1)

    useEffect(() => {
        setClickedPlayers(-1)

    }, [editing])

    const [playersPositions] = usePositionPlayerFeuilleMatch(composition, {width, height}, isSmall)

    const getPlayerNumber = (idx) => {

        const playernum = getPlayerInData(idx) && getPlayerInData(idx).numero;
        // console.log('player index ', idx, ' has number ', playernum);
        
        return playernum!==undefined && playernum!==null ? getPlayerInData(idx).numero : (isPlayerNumberValued || (getPlayerInData(idx) && !getPlayerInData(idx).numero)) ? undefined : idx+1
    }

    const getPlayerName = useCallback((idx) => {
        let dataPlayer = getPlayerInData(idx)
        let player = players.find(p=> dataPlayer && p._id === dataPlayer._id)

        if(!player)
            return 'player'
        else
            return player.lastname

    }, [data, players])

    const getPlayerInData = useCallback((idx) => {
        let playerInData = data.find(d => d && d.position === idx)

        return playerInData
    }, [data])

    return (<Box sx={{position : 'absolute', top, left, width, height}}>
            {playersPositions.map(({position}, idx) => <Box key={idx} sx={{position : 'absolute', display : 'flex', flexDirection : 'column', alignItems : 'center', textOverflow: "ellipsis",
                left : position.x-30, top : (2*position.y)-15 - height, width : 60, padding : 0, margin : 0, textAlign : 'center'}} >
                    <Box onClick={() => setClickedPlayers(idx)}>
                        {(editing) ? 
                                <Avatar sx={{ backgroundColor: 'black', width : 35, height : 35, textAlign : 'center', position : 'relative', left : '50%', transform : 'translateX(-50%)'}}>
                                    <input
                                        type="text"
                                        value={getPlayerNumber(idx)}
                                        onChange={(event) => onChangeNumber(event.target.value, idx)}
                                        style={{
                                        width: 25,
                                        height: 25,
                                        textAlign: 'center',
                                        position: 'relative',
                                        margin : 0,
                                        color: 'black',
                                        backgroundColor : 'white',
                                        fontSize : '1em'
                                        }}
                                        autoFocus={clickedPlayers===idx}
                                        onFocus={(event) => event.target.select()}
                                    />
                                </Avatar>
                                    :
                                <Avatar sx={{ backgroundColor: 'black', width : 35, height : 35, textAlign : 'center', position : 'relative', left : '50%', transform : 'translateX(-50%)'}}>{getPlayerNumber(idx)}</Avatar>}
                        <Typography noWrap component="div" sx={{width : '100%', fontWeight : 700, fontSize : '0.8em', color : 'black', display : 'inline', textAlign : 'center'}}>{getPlayerName(idx)}</Typography> 
                        {(clickedPlayers===idx && !editing) && <CustoSelect 
                                                                    inexistantList={players.filter(p => 
                                                                        data.every(d => d._id !== p._id) && subs.every(s => s._id !== p._id))
                                                                                    .sort((a,b) => a.lastname.localeCompare(b.lastname))} 
                                                                    existantList={players.filter(p => 
                                                                                            data.find(d => d._id === p._id) || subs.find(s => s._id === p._id))
                                                                                    .sort((a,b) => a.lastname.localeCompare(b.lastname))} 
                                                                    onSelect={(value) => onSelect(value, idx)} 
                                                                    onHide={() => setClickedPlayers(-1)}
                                                                />}
                    </Box>
                </Box>
            )}
    </Box>)
}






export default PositionResolver